import { useContext } from 'react';
import {
    UIConfirmationModalContext,
    UIConfirmationModalContextData
} from './context';

export function useUIConfirmationModal(): UIConfirmationModalContextData {
    const data = useContext<UIConfirmationModalContextData | undefined>(
        UIConfirmationModalContext
    );

    if (!data) {
        throw new Error(
            "UIConfirmationModalContext unavailable. Are you sure you're using this in a nested component of an UIConfirmationModalProvider?"
        );
    }

    return data;
}
